<template>
  <transition enter-active-class="transform ease-out duration-300 transition" enter-class="opacity-0" enter-to-class="opacity-100" leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div v-show="showModal" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  
  
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.
  
        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
        <div>
          <div v-if="!submitted">
            <h3 class="text-lg font-semibold leading-6 text-gray-900" id="modal-title">
              {{ job.Title }}
            </h3>
            <div class="mt-1">
              <p
                class="text-sm text-gray-600 text-left whitespace-pre-wrap"
              >{{ job.Body }}
              </p>
            </div>
            <div class="mt-4">
              <div>
                <label for="message" class="sr-only">Message</label>
                <textarea v-model="message" name="message" id="message" rows="6" class="block w-full shadow-sm text-sm text-gray-900 py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border border-gray-300 rounded-md" placeholder="Your message…" />
                <!-- <p v-if="$v.message.$dirty && !$v.message.required" class="mt-2 text-sm text-red-600">Please add some details to your enquiry.</p> -->
              </div>
            </div>
          </div>
        </div>
        <template v-if="!submitted">
          <div class="mt-4">
            <TailwindButton @click="submit" :disabled="submitting" :loading="submitting" class="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 sm:col-start-2">Submit</TailwindButton>
          </div>
          <button type="button" @click="$emit('closeModal')" class="absolute top-4 right-4 text-sm text-gray-400 underline hover:text-gray-500" style="text-decoration-thickness: 1px !important; text-underline-offset: 2px">
            <XIcon class="w-6 h-6" />
          </button>
        </template>
        <template v-else>
          <div>
            <p class="text-lg text-gray-800 font-medium text-center" style="text-wrap: balance">
              Success! Your enquiry has been submitted.
            </p>
            <TailwindButton @click="$emit('closeModal')" class="mt-4 w-full">
              Close
            </TailwindButton>
          </div>
        </template>
      </div>
    </div>
  </div>
  </transition>
</template>
<script>

import { XIcon } from '@vue-hero-icons/outline'

import TailwindButton from '@/prototype/TailwindButton.vue'
import JobBoardServices from '../../../services/JobBoardServices'

const jobBoardService = new JobBoardServices()

export default {
  components: {
    XIcon,
    TailwindButton,
  },
  props: {
    showModal: Boolean,
    job: Object,
  },
  data() {
    return {
      message: null,
      submitting: false,
      submitted: false,
    }
  },
  methods: {
    async submit() {
      this.submitting = true

      try {
        await jobBoardService.submitEnquiry(this.job.Id, this.message)
        this.submitted = true
      }
      finally {
        this.submitting = false
      }
    }
  },
}

</script>
  